import OrderChangeTaxiRequest, {
  OrderChangeTaxiRequestBody,
} from "./order-change-taxi.request";

const createBody = (
  request: OrderChangeTaxiRequest,
): OrderChangeTaxiRequestBody => {
  return {
    newTargetTaxiId: request.newTargetTaxiId,
  };
};

const orderChangeTaxiRequestFactory = {
  createBody,
};

export default orderChangeTaxiRequestFactory;
